import { Component, OnInit, Input } from '@angular/core';
import { camps } from '../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../services/camps-enum-translation.service';
import { campsenum } from '../../../models/enums.generated';

@Component({
    selector: 'app-purchase-list-row',
    templateUrl: './purchase-list-row.component.html',
    styleUrls: ['./purchase-list-row.component.scss'],
    standalone: false
})
export class PurchaseListRowComponent implements OnInit {
    @Input() public item: camps.CampPurchaseInfo;

    constructor(private translateService: CampsEnumTranslationService, private enumTranslation: CampsEnumTranslationService) {}

    ngOnInit() {}

    get status() {
        return this.translateService.purchaseStatus(this.item.status);
    }

    public get isFinalized() {
        return this.item.status === campsenum.CampPurchaseStatus.Finalized;
    }

    public get isRefunded() {
        return this.item.status === campsenum.CampPurchaseStatus.Refunded;
    }

    public getEnrolledChildren(item: camps.CampPurchaseInfo) {
        let children = '';

        item.enrolledChildren.forEach(x => {
            let sessionNames = '';

            x.sessionNames.forEach(y => {
                sessionNames += y + ', ';
            });

            children += x.name + ' (' + sessionNames.substring(0, sessionNames.length - 2) + '), ';
        });

        if (children && children.length > 2) {
            children = children.substring(0, children.length - 2);
        }
        return children;
    }

    public get campTypeLabel() {
        return this.enumTranslation.campType(this.item.campType);
    }

    public get hasEnrolledChildren(){
        return this.item && this.item.enrolledChildren && this.item.enrolledChildren.length;
    }
}
